import { render, staticRenderFns } from "./FileShare.vue?vue&type=template&id=2a79627c&scoped=true&"
import script from "./FileShare.vue?vue&type=script&lang=js&"
export * from "./FileShare.vue?vue&type=script&lang=js&"
import style0 from "./FileShare.vue?vue&type=style&index=0&id=2a79627c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a79627c",
  null
  
)

export default component.exports